export const PrivateProp = (target: Object, key: string | symbol, ...args: any[]) => {
    Object.defineProperty(target, key, {
        enumerable: false,
        configurable: false,
        writable: true,
    });
};
